import { Link } from 'react-router-dom';

export default function Navbar() {
  return (
    <nav className="nav">
      <div className="brand">
        <img src="/images/mountain_logo.png" alt="White Mountain" className="brand-logo" />
        <span>White Mountain</span>
      </div>
      <ul className="links">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/services">Services</Link></li>
        <li><Link to="/about">About Us</Link></li>
        <li><Link to="/contact">Contact Us</Link></li>
      </ul>
    </nav>
  );
}
